"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = require("react");

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * DEPRECATED: Please don't use this.
 *
 * A utility function for cloning a child component and adding styles. This is
 * useful for components that need to dictate styling of children but don't know
 * the children constructor which could be used for targetting via css selector.
 */
var _default = function _default(styles) {
  return function (component) {
    return (0, _styledComponents["default"])(function (_ref) {
      var className = _ref.className;
      return /*#__PURE__*/(0, _react.cloneElement)(component, {
        className: "" + (component.props.className + " " || "") + className
      });
    }).withConfig({
      displayName: "clone-with-styles",
      componentId: "sc-3rkt69-0"
    })(styles);
  };
};

exports["default"] = _default;